module.exports = __webpack_public_path__ + "433e8ef4982c4d6124b422c8d861226b.svg";